import { AvisoDaUrlComMarcador } from "@/components/notifications/AvisoDaUrlComMarcador";
import { useMarkPortalNotificationRead } from "@/hooks/usePortalNotifications";

/**
 * O consumidor do `?aviso=<id>` no PORTAL (D3, passo 19). O push de Central e de comprovante leva `&aviso=<id>` (molde do aviso do
 * sino): sem este consumidor o clique no push abre a página e a linha segue não lida. Marca pela API do portal.
 */
export function AvisoDaUrlDoPortal(): JSX.Element {
  const { mutateAsync } = useMarkPortalNotificationRead();
  return <AvisoDaUrlComMarcador marcarLida={mutateAsync} />;
}
